import {useTranslation} from '@/translations/i18n'
import {FormSection} from '@/components/commons/form-section/FormSection'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Divider} from '@/components/ui/divider/Divider'
import {HousingNotesSchema} from '../../formSchemas'
import {housingNotesMapToSections} from '../../utils'
import {MedicalReportTextAreaSections} from '../medical-report-text-area-sections/MedicalReportTextAreaSections'
import {QualificationJobFields} from '../qualification-job-fields/QualificationJobFields'
import {DisabilityBenefitsFields} from '../disability-benefits-fields/DisabilityBenefitsFields'
import {HousingConditionFields} from '../housing-condition-fields/HousingConditionFields'
import {FamilyNetworkSections} from '../family-network-sections/FamilyNetworkSections'
import {CareNetworkSections} from '../care-network-sections/CareNetworkSections'
import {InterestsSections} from '../interests-sections/InterestsSections'

export const InitialSocialServiceEvaluationSections = () => {
    const {t} = useTranslation()

    return (
        <>
            <FormSection title={t('medical_records:qualification_section_title')} hasBottomDivider>
                <Flexbox direction="column" gap={4} fullWidth>
                    <QualificationJobFields />
                    <DisabilityBenefitsFields />
                </Flexbox>
            </FormSection>
            <FormSection title={t('medical_records:housing_condition')}>
                <HousingConditionFields />
            </FormSection>
            <MedicalReportTextAreaSections sectionsMap={housingNotesMapToSections} schema={HousingNotesSchema} />
            <Divider direction="horizontal" />
            <FamilyNetworkSections />
            <Divider direction="horizontal" />
            <CareNetworkSections />
            <Divider direction="horizontal" />
            <InterestsSections />
        </>
    )
}
